import React, { useState } from 'react';

const Navbar = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <header className="flex flex-wrap w-full h-[90px] text-sm py-3">
        <nav className="max-w-[85rem] shadow-2xl shadow-[#ffff00] w-full mx-auto px-4 flex items-center justify-between rounded-[50px]">
          {/* Logo */}
          <a className="flex-none text-xl font-semibold focus:outline-none focus:opacity-80" href="/">
            <img src="./l11.png" alt="Logo" className="h-[60px] w-[70px] sm:h-[90px] sm:w-[105px]" />
          </a>

          {/* Navbar Links (visible on larger screens) */}
          <div className="hidden sm:flex flex-grow justify-center items-center space-x-12 ml-12">
            <a className="font-medium text-[16px] sm:text-[18px] text-black hover:font-bold" href="/">Home</a>
            <a className="font-medium text-[16px] sm:text-[18px] text-black hover:font-bold" href="#about">About</a>
            <a className="font-medium text-[16px] sm:text-[18px] text-black hover:font-bold" href="#work">Work</a>
            <a className="font-medium text-[16px] sm:text-[18px] text-black hover:font-bold" href="#skills">Skills</a>
            <a className="font-medium text-[16px] sm:text-[18px] text-black hover:font-bold" href="#project">Project</a>
          </div>

          {/* Contact Button (visible on larger screens) */}
          <div className="hidden sm:flex items-center gap-x-2">
            <a
              className="group inline-block rounded-full bg-gradient-to-r from-[#ffff00] via-[#ffff00] to-yellow-500 p-[2px] hover:text-white"
              href="#contact"
            >
              <span className="block rounded-full bg-white px-6 py-2 sm:px-8 sm:py-3 text-sm group-hover:bg-transparent text-black font-bold">
                Send Me a Message
              </span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="sm:hidden flex items-center">
            <button
              type="button"
              className="text-black hover:text-gray-500 focus:outline-none"
              aria-label="Toggle navigation"
              onClick={toggleMobileMenu}
            >
              <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </nav>

        {/* Mobile Menu Overlay */}
        {isMobileMenuOpen && (
          <div className="fixed top-0 left-0 right-0 z-50 flex flex-col h-[45%] w-full space-y-4 items-center bg-black rounded-xl shadow-2xl shadow-[#fff000] p-8">
            {/* Close Button */}
            <button
              onClick={toggleMobileMenu}
              className="absolute top-4 right-4 text-white text-2xl focus:outline-none"
              aria-label="Close menu"
            >
              &times;
            </button>

            <a className="font-medium text-[16px] text-white hover:font-bold focus:outline-none focus:text-gray-400" href="#home" onClick={toggleMobileMenu}>Home</a>
            <a className="font-medium text-[16px] text-white hover:font-bold focus:outline-none focus:text-gray-400" href="#about" onClick={toggleMobileMenu}>About</a>
            <a className="font-medium text-[16px] text-white hover:font-bold focus:outline-none focus:text-gray-400" href="#work" onClick={toggleMobileMenu}>Work</a>
            <a className="font-medium text-[16px] text-white hover:font-bold focus:outline-none focus:text-gray-400" href="#skills" onClick={toggleMobileMenu}>Skills</a>
            <a className="font-medium text-[16px] text-white hover:font-bold focus:outline-none focus:text-gray-400" href="#project" onClick={toggleMobileMenu}>Project</a>
            <hr className="bg-white w-full my-4" />

            <div className="flex justify-center">
              <a
                className="group inline-block rounded-full bg-gradient-to-r from-[#ffff00] via-[#ffff00] to-yellow-500 p-[4px] hover:text-black"
                href="#contact"
                onClick={toggleMobileMenu}
              >
                <span className="block rounded-full bg-black px-4 py-2 text-sm group-hover:bg-transparent text-white font-bold">
                  Send Me a Message
                </span>
              </a>
            </div>
          </div>
        )}
      </header>
    </>
  );
};

export default Navbar;
